import { Injectable } from '@angular/core';
import { ValidationRule } from 'src/Models/helpers/ValidationRules';

@Injectable({
    providedIn: 'root'
})
export class Generic {
    
    constructor() {

    }

    static validateProperty(value: string | null, rules: ValidationRule): boolean {
        
        if (rules.is_not_null && (value === null || value.trim() === '')) {
            return false;
        }
    
        if (rules.is_null && value !== null && value.trim() !== '') {
            return false;
        }
        
        if (rules.contains && (value === null || !(value ?? '').toString().toLowerCase().includes(rules.contains.toLowerCase()))) {
           return false;
        }
    
        if (rules.equals_to && value !== rules.equals_to) {
            return false;
        }
    
        if (rules.is_not_equals_to && value === rules.is_not_equals_to) {
            return false;
        }
    
        if (rules.not_contains && value !== null && (value ?? '').toString().toLowerCase().includes(rules.not_contains.toLowerCase())) {
           return false;
        }

        if (rules.less_or_equal_than !== undefined) {
            if (value === null || Number(value) > rules.less_or_equal_than) {
                return false;
            }
        }

        if (rules.greater_or_equal_than !== undefined) {
            if (value === null || Number(value) < rules.greater_or_equal_than) {
                return false;
            }
        }
    
        return true;
    }
}
